import request from '@/utils/request'

// 获取积分流水数据
export async function api_getPointList(params) {
  return request({
    url: '/rest/member/point/list',
    method: 'get',
    params,
  })
}

// 导出积分流水
export async function api_postPointListExport(data) {
  return request({
    url: '/rest/member/point/list/export',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 获取积分任务数据
export async function api_getPointTaskList(params) {
  return request({
    url: '/rest/member/point/task/list',
    method: 'get',
    params,
  })
}
// 修改积分任务数据
export async function api_putPointTask(data) {
  return request({
    url: '/rest/member/point/task',
    method: 'put',
    data,
  })
}
// 获取消费店铺数据
export async function api_getStoreList(params) {
  return request({
    url: '/rest/store/list',
    method: 'get',
    params,
  })
}
// 获取拍照积分列表
export async function api_getPointApplyList(params) {
  return request({
    url: '/rest/member/point/apply/list',
    method: 'get',
    params,
  })
}
// 获取拍照积分审核
export async function api_putPointCheck(data) {
  return request({
    url: '/rest/member/point/apply',
    method: 'put',
    data,
  })
}
// 获取默认积分规则
export async function api_getPointRule(params) {
  return request({
    url: '/rest/member/point/rule',
    method: 'get',
    params,
  })
}
// 获取积分规则列表
export async function api_getPointRuleList(params) {
  return request({
    url: '/rest/member/point/rule/list',
    method: 'get',
    params,
  })
}
// 更新规则
export async function api_putPointRule(data) {
  return request({
    url: '/rest/member/point/rule',
    method: 'put',
    data,
  })
}
// 新建规则
export async function api_postPointRule(data) {
  return request({
    url: '/rest/member/point/rule',
    method: 'post',
    data,
  })
}

// 导出拍照积分列表
export async function api_postPhotograpListExport(params) {
  return request({
    url: '/rest/member/point/apply/list/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 计算可赠送积分
export async function api_postComputeGivePoint(data) {
  return request({
    url: '/rest/member/point/apply/trialCalc',
    method: 'post',
    data,
  })
}
// 更新签到规则
export async function api_postCheckInUpdate(data) {
  return request({
    url: '/rest/checkIn/update',
    method: 'post',
    data,
  })
}
// 获取签到规则ID
export async function api_getCheckInRuleId(data) {
  return request({
    url: 'rest/checkIn/getCheckInRuleId',
    method: 'get',
    data,
  })
}
// 获取签到规则
export async function api_getCheckIn(params) {
  return request({
    url: '/rest/checkIn',
    method: 'get',
    params,
  })
}
//积分清零
export async function api_batchResetPoint(data) {
  return request({
    url: '/rest/member/batchResetPoint',
    method: 'put',
    data,
  })
}